import React, { Component, Fragment } from "react";
import { Image } from "react-bootstrap";
import { history } from "../../_helpers/history";
import Social from "../Social/Social";

import RCH_Logo_SM from "../../_assets/rch-logo-sm.png";

import "./style.css";

export default class Header extends Component {
  routeTo = (path) => {
    console.log();
    history.push(path);
  };

  render() {
    return (
      <Fragment>
        <header className="nav-container">
          <div className="row info-container w-100">
            <div className="col-auto text-left pr-0 mr-0">
              <Social type="social-header" />
            </div>
            <div className="col address-container text-right px-0">
              <span className="address">
                350 Terracina Blvd, Redlands CA 92373
              </span>
            </div>
          </div>
          <div className="nav-links row w-100 flex">
            <div className="rch-logo-container col-12 col-md-auto pl-0 text-center">
              <div className="rch-logo">
                <Image src="https://axs-media.s3.amazonaws.com/rch.png" fluid />
              </div>
            </div>
            <div className="col-12 col-md w-100 px-0">
              <div className="row links h-100">
                <div className="col-2 rch-logo-sm">
                  <Image className="pt-2" src={RCH_Logo_SM} fluid />
                </div>
                <div className="col link" onClick={() => this.routeTo("/")}>
                  COVID-19 Registration
                </div>
                <div className="col link" onClick={() => this.routeTo("/faq")}>
                  FAQ
                </div>
              </div>
            </div>
          </div>
        </header>
        <div className="content-container">{this.props.children}</div>
      </Fragment>
    );
  }
}
